import React, { useEffect } from 'react';
import NetInfo from '@react-native-community/netinfo';
import CustomButton from '../components/shared/CustomButton';
import { StackActions, useNavigationState } from '@react-navigation/native';
import {
    Alert,
    View,
    StyleSheet,
    Image,
    ImageBackground,
    BackHandler,
    Platform,
    Text,
    TouchableOpacity,
} from 'react-native';
import ToplearnText from './../components/shared/ToplearnText';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch } from 'react-redux';
import { decodeToken } from './../utils/token';
import { customToast } from './../utils/toasts';
import { userAction, getHistories, getZirmajmoeh } from './../actions/index';
import { useSelector } from 'react-redux';
import DownloadLink from 'react-download-link';
import DownloadService from '../api/DownloadAppService';
import axios from 'axios';
import * as FileSystem from 'expo-file-system';
import saveFileByUrl from 'save-file-by-url';

const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then((response) => response.text())
                .then((data) => {
                    resolve(data);
                });
        });
    }, 2000);

const downloadApp = async () => {
    var FileSaver = require('file-saver');
    FileSaver.saveAs(
        'https://hamyarinoorapi.hsprojects.ir/api/downloadAndroidApp',
        'hamyarinoor.apk'
    );
};

const confirmationAlert = () => {
    return Alert.alert(
        'ارتباط با سرور',
        `برای استفاده از اپلیکیشن باید به اینترنت متصل باشید`,
        [
            {
                text: 'باشه',
                onPress: BackHandler.exitApp,
            },
        ],
        { cancelable: false }
    );
};

const WelcomeScreen = ({ navigation }) => {
    const screenIndex = useNavigationState((state) => state.index);
    const dispatch = useDispatch();

    useEffect(() => {
        let currentCount = 0;

        if (screenIndex <= 0) {
            BackHandler.addEventListener('hardwareBackPress', () => {
                if (currentCount === 1) {
                    BackHandler.exitApp();
                    return true;
                }

                currentCount += 1;
                customToast('برای خروج دوباره دکمه برگشت را لمس بنمایید');

                setTimeout(() => {
                    currentCount = 0;
                }, 1000);

                return true;
            });
        }
    }, []);

    useEffect(() => {
        const checkForNet = async () => {
            const state = await NetInfo.fetch();

            if (!state.isConnected) confirmationAlert();
            else {
                const token = await AsyncStorage.getItem('token');
                const userId = JSON.parse(await AsyncStorage.getItem('userId'));
                if (token !== null && userId !== null) {
                    const decodedToken = decodeToken(token);

                    dispatch(userAction(decodedToken.user));
                    dispatch(getHistories());
                    dispatch(getZirmajmoeh());

                    if (decodedToken.user.userId === userId)
                        navigation.dispatch(StackActions.replace('Home'));
                    else {
                        await AsyncStorage.removeItem('token');
                        await AsyncStorage.removeItem('userId');
                        navigation.navigate('Login');
                    }
                }
            }
        };
        if (Platform.OS === 'android' || Platform.OS === 'ios') checkForNet();
    }, []);
    return (
        <ImageBackground
            source={require('../assets/bg1.jpg')}
            style={styles.background}
            blurRadius={3}
        >
            {Platform.OS==='web'?<View style={styles.appDownload}>
                {/* <DownloadLink
                    label="Download"
                    filename="https://hamyarinoorapi.hsprojects.ir/api/downloadAndroidApp"
                    exportFile={() => 'My cached data'}
                /> */}
                <TouchableOpacity onPress={downloadApp}>
                    <Image
                        source={require('../assets/android.png')}
                        style={[styles.appDownloadImage, { marginRight: 5 }]}
                    />
                </TouchableOpacity>
                {/* <Image
                    source={require('../assets/ios.png')}
                    style={styles.appDownloadImage}
                /> */}
            </View>:null}
            <View style={styles.logoContainer}>
                <Image
                    source={require('../assets/logo.png')}
                    style={styles.logo}
                />
                <ToplearnText
                    fontFamily="ih"
                    size="2"
                    styles={styles.firstText}
                >
                    شفافیت ، سرعت و دقت در اطلاعات صندوق همیاری نور
                </ToplearnText>
            </View>
            <View style={styles.buttonContainer}>
                <CustomButton
                    title="ورود"
                    color="royalblue"
                    onPress={() => navigation.navigate('Login')}
                />
                <CustomButton
                    title="ثبت نام"
                    onPress={() => navigation.navigate('Register')}
                />
            </View>
            {/* <View style={styles.appDownload}>

            </View> */}
        </ImageBackground>
    );
};

export default WelcomeScreen;

const styles = StyleSheet.create({
    background: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    buttonContainer: {
        width: '100%',
        padding: 20,
    },
    firstText: {
        top: 25,
        color: 'tomato',
    },
    logo: {
        width: 190,
        height: 190,
    },
    logoContainer: {
        position: 'absolute',
        top: 70,
        alignItems: 'center',
    },
    appDownload: {
        position: 'absolute',
        flexDirection: 'row',
        width: '100%',
        padding: 10,
        top: 10,
        alignItems: 'flex-start',
    },
    appDownloadImage: {
        width: 180,
        height: 43,
        resizeMode: 'stretch',
        borderRadius: 10,
    },
});
